export default {
  "5": {
    text: "Haben Sie aktuell Beschwerden?",
    type: "buttons",
    options: [{ value: "Ja" }, { value: "Nein" }],
    info:
      "Geben Sie bitte an, ob Sie aktuell Beschwerden oder Schmerzen haben.",
  },
};
